export var EMPOWER_TYPE;
(function (EMPOWER_TYPE) {
    EMPOWER_TYPE["GENERAL"] = "GENERAL";
    EMPOWER_TYPE["AIR_HOME"] = "AIR_HOME";
    EMPOWER_TYPE["FMEA"] = "FMEA";
    EMPOWER_TYPE["MONITOR"] = "MONITOR";
    EMPOWER_TYPE["TECH_RESEARCH"] = "TECH_RESEARCH";
    EMPOWER_TYPE["TECH_MIND"] = "TECH_MIND";
})(EMPOWER_TYPE || (EMPOWER_TYPE = {}));
export var CHANNEL_SOURCE;
(function (CHANNEL_SOURCE) {
    CHANNEL_SOURCE["AIR_EUREKA"] = "dialog_signup_eureka";
})(CHANNEL_SOURCE || (CHANNEL_SOURCE = {}));
